export var StampDutyPropertyState;
(function (StampDutyPropertyState) {
    StampDutyPropertyState["NSW"] = "NSW";
    StampDutyPropertyState["QLD"] = "QLD";
    StampDutyPropertyState["WA"] = "WA";
    StampDutyPropertyState["VIC"] = "VIC";
    StampDutyPropertyState["TAS"] = "TAS";
    StampDutyPropertyState["ACT"] = "ACT";
    StampDutyPropertyState["NT"] = "NT";
    StampDutyPropertyState["SA"] = "SA";
})(StampDutyPropertyState || (StampDutyPropertyState = {}));
//# sourceMappingURL=index.js.map